import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.inquiryStatuses;
export const inquiryStatusesSelector = (state: RootState) => getState(state).data;
export const inquiryStatusesIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const inquiryStatusesIsReadySelector = (state: RootState) => getState(state).isReady;
export const inquiryStatusesErrorSelector = (state: RootState) => getState(state).error;
